<template>
  <div class="d-flex justify-space-between align-center px-4 py-4 border">
    <div v-if="isConversationOpen" class="d-flex">
      <app-icon-ai-assistant
        :width="28"
        :height="28"
        data-locator="pane-icon"
      />
      <span class="text--x-large font-weight-bold" data-locator="mobile-pane-header-title">
        {{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}
      </span>
    </div>
    <app-button
      type="ghost"
      variant="neutral"
      data-locator="mobile-pane-header-toggle-button"
      @click="$emit('toggle-conversation')"
    >
      <app-material-icon v-if="!isConversationOpen" name="arrow_back" />
      {{ $t(`${TRANSLATION_KEY_PREFIX}.${isConversationOpen ? 'openSidebar' : 'closeSidebar' }`) }}
      <app-material-icon v-if="isConversationOpen" name="arrow_forward" />
    </app-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantPaneMobileHeader'

export default defineComponent({
  name: 'AIAssistantPaneMobileHeader',
  props: {
    isConversationOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  emits: ['toggle-conversation'],
})
</script>
